import { alpha, useTheme } from "@mui/material";
import { toolTipTextSize } from "../../../privacyTheme";
import { createSxStyles } from "../../../common/createSxStyles";

export const useSharingsBaseTableStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        pre: {
            fontFamily: theme.typography.fontFamily,
            fontSize: toolTipTextSize,
        },
        entityRole: {
            color: alpha(theme.palette.primary.main, 0.7),
            "& a": {
                fontWeight: "bold",
            },
        },
        legalEntity: {
            color: theme.palette.primary.dark,
            display: "flex",
            alignItems: "center",
            "& svg": {
                fill: theme.palette.error.light,
                marginLeft: theme.spacing(0.5),
                height: 17,
                width: 17,
            },
        },
        tooltipIcon: {
            marginTop: 5 + "px",
            "& svg": {
                width: 14,
                height: 14,
            },
        },
    });
};
